export const updateFormState = (payload) => ({
    type: 'UPDATE_ORDERS_ITEMS_FILTERS_FORM',
    payload
}); 


// WEBPACK FOOTER //
// ./src/components/Pages/Items/actions.js